// Pure formatting/escaping helpers — dates, money, HTML-escaping, IDs-adjacent
// string utilities. No DOM, no app state. Extracted verbatim from
// public/index.html's inline script (Phase 2 modularization).
import { stripAccents } from './text.js';

export function esc(s) {
  return (s == null ? '' : String(s)).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
}

export function money(n) {
  n = Number(n || 0);
  return n.toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' DH';
}

export function todayISO() {
  const d = new Date();
  return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
}

export function monthKey(d) {
  return (d || '').slice(0, 7);
}

export function curMonth() {
  return todayISO().slice(0, 7);
}

export function monthLabel(m) {
  if (!m) return '';
  const [y, mo] = m.split('-');
  const names = ['', 'janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  return (names[+mo] || mo) + ' ' + y;
}

export function nowStr() {
  return new Date().toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function fmtDate(d) {
  if (!d) return '—';
  const x = new Date(d);
  return isNaN(x) ? d : x.toLocaleDateString('fr-FR');
}

export function nextOrderNo() {
  const d = new Date();
  return 'CMD-' + String(d.getDate()).padStart(2, '0') + String(d.getMonth() + 1).padStart(2, '0') + d.getFullYear() + '-' + String(Math.floor(10000 + Math.random() * 89999));
}

export function normKey(s) {
  return stripAccents((s || '').toLowerCase()).replace(/[^a-z0-9]+/g, ' ').trim();
}

// CSV formula-injection guard (OWASP): a cell whose text starts with
// =, +, -, @, tab or CR is auto-executed as a formula by Excel/Sheets when
// the file is opened. Plain numbers (including negatives like a discount or
// margin) are left as-is so they still open as numbers instead of text.
// See REFACTOR_SECURITY_REPORT.md §3.11.
export function csvSafe(value) {
  const v = String(value);
  if (/^-?\d+(\.\d+)?$/.test(v)) return v;
  return /^[=+\-@\t\r]/.test(v) ? "'" + v : v;
}

// Product photos are normally Firebase Storage download URLs, but a restored
// backup JSON sets p.imageUrl from file content with no schema validation.
// javascript:/data: URLs don't execute from an <img src>, but reject
// anything but http(s) before rendering anyway — defense in depth. See
// REFACTOR_SECURITY_REPORT.md §3.10.
export function safeImageUrl(url) {
  return /^https?:\/\//i.test(url || '') ? esc(url) : '';
}
